<template>
  <div class="page-detail-lxgc">
    <!-- 基本信息 -->
    <div class="section-title">| 基本信息</div>
    <div class="section-body">
      <div class="info-row">
        <span class="info-field info-field-wrap">
          <span class="info-label">{{ detail.fromType === '1' ? '报修人姓名：' : '需求人姓名：' }}</span>
          <span class="info-value">{{ detail.requesterName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">手机号：</span>
          <span class="info-value">{{ detail.phone || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">{{ detail.fromType === '1' ? '报修类型：' : '施工类型：' }}</span>
          <span class="info-value">{{ detail.bxlxName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">报修地点：</span>
          <span class="info-value">{{ detail.address || '-' }}</span>
        </span>
        <span class="info-field info-field-wrap">
          <span class="info-label">详细地址：</span>
          <span class="info-value">{{ detail.detailAddress || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">供应商：</span>
          <span class="info-value">{{ detail.gysName || '-' }}</span>
        </span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '故障描述：' : '项目描述：' }}</span>
        <span class="info-value info-value-multiline">{{ detail.projectDescription || '-' }}</span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '报修图片：：' : '项目图片：' }}</span>
        <div class="img-list" v-if="imgList.length">
          <a-upload :file-list="imgList" list-type="picture-card" :show-upload-button="false" :disabled="true" @preview="handlePreview" />
        </div>
        <span v-else class="info-value">-</span>
      </div>
    </div>

    <!-- 报价分项信息 -->
    <div class="section-title">| 分项信息-报价</div>
    <div class="section-body">
      <div class="table-wrapper">
        <a-table
          :columns="columns"
          :data-source="bjProjectList"
          :pagination="bjPagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 1120 }"
          bordered
          @change="p => handleTableChange(p, 'bj')"
          style="margin-top: 16px;"
        >
          <template slot="index" slot-scope="text, record, index">
            {{ (bjPagination.current - 1) * bjPagination.pageSize + index + 1 }}
          </template>
          <template slot="isCenterPurchasingPrice" slot-scope="text">
            {{ text === '1' ? '是' : '否' }}
          </template>
          <template slot="projectCharacteristics" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
          <template slot="remark" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
        </a-table>
        <div class="total-row">合计（元）：{{ bjTotalPrice }}</div>
      </div>
    </div>

    <!-- 报价审核信息 -->
    <template v-if="bjAuditList.length > 0">
      <div class="section-title">| 审核信息-报价</div>
      <div class="section-body">
        <a-table
          :columns="auditColumnsWithFile"
          :data-source="bjAuditList"
          :pagination="false"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 680 }"
          bordered
        >
          <template slot="auditStatus" slot-scope="text">
            {{ text === '1' ? '同意' : '驳回' }}
          </template>
          <template slot="auditFile" slot-scope="text, record">
            <a v-if="record.fileUrl" :href="record.fileUrl" target="_blank" class="file-link">{{ text || '附件' }}</a>
            <span v-else>-</span>
          </template>
        </a-table>
      </div>
    </template>

    <!-- 变更分项信息 -->
    <template v-if="detail.bgStep === '1'">
      <div class="section-title">| 分项信息-工程变更</div>
      <div class="section-body">
        <div class="table-wrapper">
          <a-table
            :columns="columns"
            :data-source="bgProjectList"
            :pagination="bgPagination"
            :row-key="(_, i) => String(i)"
            :scroll="{ x: 1120 }"
            bordered
            @change="p => handleTableChange(p, 'bg')"
            style="margin-top: 16px;"
          >
            <template slot="index" slot-scope="text, record, index">
              {{ (bgPagination.current - 1) * bgPagination.pageSize + index + 1 }}
            </template>
            <template slot="isCenterPurchasingPrice" slot-scope="text">
              {{ text === '1' ? '是' : '否' }}
            </template>
            <template slot="projectCharacteristics" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
            <template slot="remark" slot-scope="text">
              <div class="cell-multiline">{{ text || '-' }}</div>
            </template>
          </a-table>
          <div class="total-row">合计（元）：{{ bgTotalPrice }}</div>
        </div>
      </div>

      <!-- 变更审核信息 -->
      <template v-if="bgAuditList.length > 0">
        <div class="section-title">| 审核信息-工程变更</div>
        <div class="section-body">
          <a-table
            :columns="auditColumns"
            :data-source="bgAuditList"
            :pagination="false"
            :row-key="(_, i) => String(i)"
            :scroll="{ x: 560 }"
            bordered
          >
            <template slot="auditStatus" slot-scope="text">
              {{ text === '1' ? '同意' : '驳回' }}
            </template>
          </a-table>
        </div>
      </template>
    </template>

    <!-- 验收分项信息 -->
    <div class="section-title">| 分项信息-验收</div>
    <div class="section-body">
      <div class="table-wrapper">
        <a-table
          :columns="columns"
          :data-source="ysProjectList"
          :pagination="ysPagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 1120 }"
          bordered
          @change="p => handleTableChange(p, 'ys')"
          style="margin-top: 16px;"
        >
          <template slot="index" slot-scope="text, record, index">
            {{ (ysPagination.current - 1) * ysPagination.pageSize + index + 1 }}
          </template>
          <template slot="isCenterPurchasingPrice" slot-scope="text">
            {{ text === '1' ? '是' : '否' }}
          </template>
          <template slot="projectCharacteristics" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
          <template slot="remark" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
        </a-table>
        <div class="total-row">合计（元）：{{ ysTotalPrice }}</div>
      </div>
    </div>

    <!-- 验收审核信息 -->
    <template v-if="ysAuditList.length > 0">
      <div class="section-title">| 审核信息-验收</div>
      <div class="section-body">
        <a-table
          :columns="auditColumns"
          :data-source="ysAuditList"
          :pagination="false"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 560 }"
          bordered
        >
          <template slot="auditStatus" slot-scope="text">
            {{ text === '1' ? '同意' : '驳回' }}
          </template>
        </a-table>
      </div>
    </template>

    <!-- 审批操作 -->
    <div class="section-title">| 审批</div>
    <div class="section-body">
      <a-form :form="auditForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="审核结果">
          <a-radio-group
            v-decorator="['auditStatus', { rules: [{ required: true, message: '请选择审核结果' }] }]"
          >
            <a-radio value="1">通过</a-radio>
            <a-radio value="0">驳回</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="审批意见" required>
          <a-textarea
            v-decorator="['auditDescription', {
              rules: [
                { required: true, message: '请输入审批意见' },
                { max: 200, message: '最多200个字符' }
              ]
            }]"
            :rows="4"
            placeholder="请输入审批意见"
            :maxLength="200"
            style="max-width: 480px;"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 4 }">
          <a-button type="primary" :loading="submitting" @click="handleSubmit">提交审批</a-button>
          <a-button style="margin-left: 8px;" @click="handleCancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img style="width: 100%;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
function makePagination () {
  return {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: total => `总共${total}条数据`,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['10', '20', '50']
  }
}

export default {
  name: 'AcceptApproval',
  data () {
    return {
      detail: {},
      stageInfo: {
        bj: { solutionDescription: '', startDate: '', endDate: '', fileList: [] },
        bg: { solutionDescription: '', startDate: '', endDate: '', fileList: [] },
        ys: { solutionDescription: '', startDate: '', endDate: '', fileList: [] }
      },
      imgList: [],
      previewVisible: false,
      previewImage: '',
      bjProjectList: [],
      bjTotalPrice: '0.00',
      bjPagination: makePagination(),
      bgProjectList: [],
      bgTotalPrice: '0.00',
      bgPagination: makePagination(),
      ysProjectList: [],
      ysTotalPrice: '0.00',
      ysPagination: makePagination(),
      allAuditList: [],
      bjAuditList: [],
      bgAuditList: [],
      ysAuditList: [],
      auditForm: this.$form.createForm(this),
      submitting: false,
      columns: [
        { title: '序号', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
        { title: '是否集采价', dataIndex: 'isCenterPurchasingPrice', scopedSlots: { customRender: 'isCenterPurchasingPrice' }, width: 100, align: 'center' },
        { title: '分项工程名称', dataIndex: 'projectName', width: 150, align: 'center' },
        { title: '项目特征描述', dataIndex: 'projectCharacteristics', scopedSlots: { customRender: 'projectCharacteristics' }, width: 200, align: 'center' },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '工程量', dataIndex: 'projectQuantity', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'price', width: 180, align: 'center' },
        { title: '含税合价（元）', dataIndex: 'totalPrice', width: 120, align: 'center' },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 150, align: 'center' }
      ],
      auditColumns: [
        { title: '审核人', dataIndex: 'auditor', width: 100, align: 'center' },
        { title: '审核时间', dataIndex: 'auditDate', width: 160, align: 'center' },
        { title: '审核结果', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
        { title: '审核意见', dataIndex: 'auditDescription', width: 200, align: 'center' }
      ],
      auditColumnsWithFile: [
        { title: '审核人', dataIndex: 'auditor', width: 100, align: 'center' },
        { title: '审核时间', dataIndex: 'auditDate', width: 160, align: 'center' },
        { title: '审核结果', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
        { title: '审核意见', dataIndex: 'auditDescription', width: 200, align: 'center' },
        { title: '附件', dataIndex: 'fileName', scopedSlots: { customRender: 'auditFile' }, width: 120, align: 'center' }
      ]
    }
  },
  computed: {},
  mounted () {
    const id = this.$route.query.id
    if (id) {
      this.loadDetail(id)
      this.loadStageInfo()
      this.loadAllProjects()
      this.loadAuditList()
    }
  },
  methods: {
    loadDetail (id) {
      this.$axios.post('/api/lxgc/detail.do', { id }).then(res => {
        this.detail = (res.data && res.data.data) || {}
        const imgList = (res.data && res.data.imgList) || []
        this.imgList = imgList.map((item, i) => ({
          uid: item.id || String(i),
          name: item.fileName || `图片${i + 1}`,
          status: 'done',
          thumbUrl: item.fileFullName,
          url: item.fileFullName
        }))
      })
    },
    loadStageInfo () {
      this.$axios.post('/api/lxgc/stageInfoList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        const apply = (stage) => {
          const info = data[stage] || {}
          this.$set(this.stageInfo, stage, {
            solutionDescription: info.solutionDescription || '',
            startDate: info.startDate || '',
            endDate: info.endDate || '',
            fileList: info.fileList || []
          })
        }
        apply('bj')
        apply('bg')
        apply('ys')
      })
    },
    loadAllProjects () {
      this.$axios.post('/api/lxgc/allProjectList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.bjProjectList = data.bj || []
        this.bgProjectList = data.bg || []
        this.ysProjectList = data.ys || []
        this.bjPagination = { ...this.bjPagination, total: this.bjProjectList.length }
        this.bgPagination = { ...this.bgPagination, total: this.bgProjectList.length }
        this.ysPagination = { ...this.ysPagination, total: this.ysProjectList.length }
        this.bjTotalPrice = this.calcStageTotal(this.bjProjectList)
        this.bgTotalPrice = this.calcStageTotal(this.bgProjectList)
        this.ysTotalPrice = this.calcStageTotal(this.ysProjectList)
      })
    },
    calcStageTotal (list) {
      // 使用字符串加法处理大数，避免 IEEE 754 精度丢失（如 11111111100000000 + 5 = 11111111100000004）
      // 将金额规整为两位小数的整数字符串（cents），逐位相加后再还原为 xxx.xx 形式
      const toCents = (val) => {
        if (val === null || val === undefined || val === '') return '0'
        const str = String(val).trim()
        if (!/^-?\d+(\.\d+)?$/.test(str)) return '0'
        const negative = str.startsWith('-')
        const abs = negative ? str.slice(1) : str
        const [intPart, decPart = ''] = abs.split('.')
        const dec2 = (decPart + '00').slice(0, 2)
        const combined = ((intPart || '0') + dec2).replace(/^0+(?=\d)/, '')
        return negative ? '-' + combined : combined
      }
      const addStrings = (a, b) => {
        // 只处理非负字符串加法（本场景 totalPrice 均为非负）
        const aa = a.replace(/^-/, '')
        const bb = b.replace(/^-/, '')
        let i = aa.length - 1
        let j = bb.length - 1
        let carry = 0
        let out = ''
        while (i >= 0 || j >= 0 || carry) {
          const x = i >= 0 ? aa.charCodeAt(i--) - 48 : 0
          const y = j >= 0 ? bb.charCodeAt(j--) - 48 : 0
          const s = x + y + carry
          carry = s >= 10 ? 1 : 0
          out = (s % 10) + out
        }
        return out
      }
      const formatCents = (cents) => {
        const s = cents.padStart(3, '0')
        return s.slice(0, -2) + '.' + s.slice(-2)
      }
      const sum = (list || []).reduce((acc, row) => addStrings(acc, toCents(row.totalPrice)), '0')
      return formatCents(sum)
    },
    handleTableChange (pager, stage) {
      const paginationKey = stage + 'Pagination'
      this[paginationKey] = { ...this[paginationKey], current: pager.current, pageSize: pager.pageSize }
    },
    loadAuditList () {
      this.$axios.post('/api/lxgc/allAuditList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.bjAuditList = data.bj || []
        this.bgAuditList = data.bg || []
        this.ysAuditList = data.ys || []
      })
    },
    handleSubmit () {
      this.auditForm.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        this.$axios.post('/api/lxgc/audit.do', {
          lxgcId: this.$route.query.id,
          step: '3',
          ...values
        }).then(() => {
          this.$message.success('审批提交成功')
          this.$router.push({ path: '/minorWorks' })
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    handleCancel () {
      this.$router.push({ path: '/minorWorks' })
    },
    handlePreview (file) {
      this.previewImage = file.url
      this.previewVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-detail-lxgc {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 64px);

  .section-title {
    color: #1890ff;
    font-size: 14px;
    margin-bottom: 16px;
    margin-top: 24px;

    &:first-child { margin-top: 0; }
  }

  .section-body {
    padding: 0 0 16px 16px;

    .info-row {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      margin-bottom: 16px;

      .info-field {
        margin-right: 48px;
        margin-bottom: 8px;
      }

      .info-field-wrap {
        display: inline-flex;
        align-items: flex-start;
        max-width: 100%;

        .info-value {
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    .info-row-full {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      flex-wrap: wrap;
    }

    .info-label {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      white-space: nowrap;
    }

    .info-value {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
    }

    .info-value-multiline {
      word-break: break-all;
      white-space: pre-wrap;
      flex: 1;
      max-width: calc(100% - 100px);
    }

    .cell-multiline {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
      text-align: left;
      min-width: 120px;
    }

    .file-link {
      color: #1890ff;
      text-decoration: none;
      &:hover { text-decoration: underline; }
    }

    .file-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 4px;

      .file-item {
        display: flex;
        align-items: center;
      }
    }

    .img-list {
      margin-top: 4px;
    }
  }

  .table-wrapper {
    position: relative;
    margin-top: 16px;

    .total-row {
      position: absolute;
      bottom: 10px;
      left: 0;
      line-height: 32px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }
}
</style>
